import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import SmallDetailBox from '../../components/common/DetailBox/SmallDetailBox';
import LargeDetailBox from '../../components/common/DetailBox/LargeDetailBox';
import LargeDetailTextBox from '../../components/common/DetailBox/LargeDetailTextBox';
import './CustomerDetail.css';
import './UserDetail.css';
import { baseurl } from '../../api';
import './PersonalProfile.css'
import apiClient from '../../api';
import SelectBoxSmall from '../../components/common/SelectBox/SelectBoxSmall';
import InputBoxLarge from '../../components/common/InputBox/InputBoxLarge';
import InputBoxSmall from '../../components/common/InputBox/InputBoxSmall';
import InputAndSelectWithIconBoxSmall from '../../components/common/InputBox/InputAndSelectCompo';
import authenticatedAxios from '../../authenticatedAxios';
import { showAlert } from '../../components/common/ExportLabel/Exporterror';

const PersonalProfile = () => {
    const [userDetail, setUserDetail] = useState(null);
    const [formValues, setFormValues] = useState([]);
    const [loading, setLoading] = useState(true);
    const [countries, setCountries]= useState([]);
    const [error, setError] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [userRoles, setUserRoles] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [profilePicFile, setProfilePicFile] = useState(null);
    const [profilePicPreview, setProfilePicPreview] = useState(null);
    const profile_url = userDetail?.profile_pic
        ? `${baseurl.slice(0, -1)}/${userDetail.profile_pic.replace(/^\//, "")}`
        : null;
    const navigate = useNavigate();

    useEffect(() =>{
        console.log(userDetail)
    },[userDetail])

    useEffect(() =>{
        console.log("FORM",formValues)
    },[formValues])


    useEffect(() => {
        const fetchRolesAndLanguages = async () => {
            try {
                const roleResponse = await authenticatedAxios.get(`${baseurl}accounts/roles/internal/`);
                setUserRoles(roleResponse.data.data || []);

                const languageResponse = await authenticatedAxios.get(`${baseurl}localization/languages/`);
                setLanguages(languageResponse.data.data || []);

                const countryResponse = await authenticatedAxios.get(`${baseurl}localization/country/`);
                setCountries(countryResponse.data.data || []);

            } catch (err) {
                setError('Failed to fetch roles or languages.');
            }
        };
        fetchRolesAndLanguages();
    },[]);


    useEffect(() => {

        fetchProfile();
    },[]);

    const fetchProfile = async () => {
        try {
            const response = await apiClient.get('accounts/personal-user/profile/');
            setUserDetail(response.data.data);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch profile data.');
            setLoading(false);

            if (err.response && err.response.status === 401) {
                navigate('/login');
            }
        }
    };

    const handleUserEditClick = () => {
        setIsEdit(true);
    };

    const handleInputChange = (field, value) => {
        setFormValues(prev => ({
          ...prev,
          [field]: value,
        }));

        setUserDetail(prev => ({
            ...prev,
            [field]: value,
          }));
      
      };

    const handleProfilePicChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setProfilePicFile(file);
            setProfilePicPreview(URL.createObjectURL(file));
        }
    };

    const handleEditProfilePic = () => {
        document.getElementById('profile-pic-input').click();
    };


    const handleUserUpdate = async () => {
        if (!profilePicFile && Object.keys(formValues).length === 0) {
            setIsEdit(false);
            setError(null);
            return;
        }
    
        try {
            let dataToSend = formValues;
    
            // If a file is present, use FormData
            if (profilePicFile) {
                const formData = new FormData();
                formData.append('profile_pic', profilePicFile);
    
                for (const key in formValues) {
                    formData.append(key, formValues[key]);
                }
    
                dataToSend = formData;
            }
    
            const response = await apiClient.put('accounts/personal-user/profile/', dataToSend, {
                headers: profilePicFile ? { 'Content-Type': 'multipart/form-data' } : {},
            });
    
            if (response.data.response_code === 1) {
                fetchProfile(); // Refresh latest profile data
                setIsEdit(false);
                setFormValues([]);
                setProfilePicPreview(null);
                setError(null);
            }
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Something went wrong!';
            showAlert(errorMessage);
        }
    };
    
    

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="whole-container">
            <div className="top-heading">
                <PageHeader pageName="My Profile" />
            </div>

            {!isEdit ? (
                <div className="User-detail-container detail-container">
                    <div className="my-profile-whole left-user-details-whole">
                        <div className="my-profile-top bg-blue company-left-first left-customer">
                            <div className="company-img-name-container">
                                <div className="company-img-container">
                                    <img
                                        src={profilePicPreview || `${profile_url}`}
                                        alt="Profile"
                                        className="comp-img user-image"
                                    />
                                </div>
                                <div>
                                    <span className="common-text fts-17 white">{userDetail.full_name || 'N/A'}</span>
                                    <span className="common-text fts-13 white">{userDetail.email || 'N/A'}</span>
                                </div>
                            </div>
                            <div className="company-edit-button">
                                <button className="fts-15 black" onClick={handleUserEditClick}>
                                    Edit
                                </button>
                            </div>
                        </div>
                        <div className="company-left-second left-customer">
                          <LargeDetailBox label="Name" value={userDetail.full_name || 'N/A'} />
                          <SmallDetailBox label="Email" value={userDetail.email|| 'N/A'} />
                          <SmallDetailBox
                                label="Mobile Number"
                                value={`${userDetail.country_code?.country_code || ''} ${userDetail.phone || 'N/A'}`}
                            />

                          <SmallDetailBox label="User Role" value={userDetail.role?.name || 'N/A'} />
                          <SmallDetailBox label="User Type" value={userDetail.user_type || 'N/A'} />

                          <SmallDetailBox label="Preferred Language" value={userDetail.preferred_language?.name || 'N/A'} />
                          <SmallDetailBox label="User Time Zone" value={userDetail.time_zone || 'N/A'} />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="User-detail-container edit-container">
                    <div className="my-profile-whole left-user-details-whole">
                        <div className="my-profile-top bg-blue company-left-first left-customer">
                            <div className="company-img-name-container">
                                <div className="company-img-container">
                                    <img
                                        src={profilePicPreview || `${profile_url}`}
                                        alt="Profile Preview"
                                        className="comp-img user-image"
                                    />
                                    <img
                                        src="/assets/company_edit.png"
                                        alt="edit"
                                        className="edit-company"
                                        onClick={handleEditProfilePic}
                                    />
                                    <input
                                        id="profile-pic-input"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={handleProfilePicChange}
                                    />
                                </div>
                                <div>
                                    <span className="common-text fts-17 white">{userDetail.full_name || 'N/A'}</span>
                                    <span className="common-text fts-13 white">{userDetail.email || 'N/A'}</span>
                                </div>
                            </div>
                            <div className="company-edit-button">
                                <button className="fts-15 black" onClick={handleUserUpdate}>
                                    Save
                                </button>
                            </div>
                        </div>
                        <div className=" left-customer">
                            <InputBoxLarge
                            label="Name"
                            border='blue-border'
                            defaultValue={userDetail.full_name}
                            onChange={(e) => handleInputChange("full_name", e.target.value)}
                            />
                            <div className='user-edit-box'>
                                <InputBoxSmall
                                label="Email"
                                className='w-50'
                                border='blue-border'
                                defaultValue={userDetail.email}
                                onChange={(e) => handleInputChange("email", e.target.value)}
                                />

                                <InputAndSelectWithIconBoxSmall
                                    label="Mobile Number"
                                    name="phone"
                                    className='w-50'
                                    opt="country_code"
                                    border='blue-border'
                                    options={countries.map(c => ({
                                        value: c.id.toString(),
                                        label: c.country_code
                                    }))}
                                    onChange={(e) => handleInputChange("phone", e.target.value)}
                                    selectchange={(e) => handleInputChange("country_code", e.target.value)}
                                    defaultValue={userDetail?.phone || ''}
                                    defaultOption={userDetail?.country_code?.id}
                                />
                            </div>
                            <div className='user-edit-box'>
                                <SelectBoxSmall
                                    label="User Role"
                                    className='w-50'
                                    border='blue-border'
                                    options={userRoles.map((role) => ({ value: role.id, label: role.name }))}
                                    defaultValue={userDetail?.role?.id || ''}
                                    onChange={(e) => handleInputChange("role", e.target.value)}
                                />
                                <SelectBoxSmall
                                    label="User Type"
                                    className='w-50'
                                    border='blue-border'
                                    options={[
                                        { value: 'Vansaler', label: 'Vansaler' },
                                        { value: 'Employee', label: 'Employee' },
                                        { value: 'Both', label: 'Both' },
                                    ]}
                                    defaultValue={userDetail?.user_type || ''}
                                    onChange={(e) => handleInputChange("user_type", e.target.value)}
                                />
                            </div>
                            <div className='user-edit-box'>
                                
                                 <SelectBoxSmall
                                    label="Preferred Language"
                                    className='w-50'
                                    border='blue-border'
                                    options={languages.map((language) => ({ value: language.id, label: language.name }))}
                                    defaultValue={userDetail?.preferred_language?.id || ''}
                                    onChange={(e) => handleInputChange("preferred_language", e.target.value)}
                                />
                                <InputBoxSmall
                                    label="User Timezone"
                                    className='w-50'
                                    border='blue-border'
                                    readOnly
                                    defaultValue='Coming Soon'
                                    // options={[
                                    //     { value: 'Asia/Kolkata', label: 'Asia/Kolkata (IST)' },
                                    //     { value: 'America/New_York', label: 'America/New_York (EST)' },
                                    // ]}
                                    // defaultValue={userDetail?.time_zone || ''}
                                    // onChange={(e) => setUserDetail({ ...userDetail, time_zone: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PersonalProfile;
